import firebase from "firebase";


const firebaseConfig = {

    apiKey: "AIzaSyAUoaDSvR2PFSEDdPuTNAOhiQNxxussBmI",

    authDomain: "vuex-b9c28.firebaseapp.com",

    databaseURL: "https://vuex-b9c28.firebaseio.com",

    projectId: "vuex-b9c28",

    storageBucket: "",

    messagingSenderId: "288255103627",

    appId: "1:288255103627:web:4a05037245ec7c1d333a8e",

    measurementId: "G-XY9J34SL5C"

  };

  // Initialize Firebase

  const firebaseApp = firebase.initializeApp(firebaseConfig);

//  firebase.analytics();

  export default firebaseApp.firestore();